import { Button } from "@/components/ui/button";
import { Rocket, Filter, Layers, ArrowRight } from "lucide-react";

const features = [
  { icon: Rocket, title: "Speed", desc: "Fill positions in days, not months." },
  { icon: Filter, title: "Quality", desc: "Pre-screened, role-fit candidates only." },
  { icon: Layers, title: "Scale", desc: "From 10 to 1,000+ hires in a single drive." },
];

export default function BulkHiring() {
  const scrollToContact = () => {
    const el = document.getElementById("contact");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };
  return (
    <section
      id="bulk-hiring"
      className="py-20 lg:py-28 bg-[hsl(var(--bee-teal-dark))] text-white relative overflow-hidden"
      data-testid="bulk-hiring-section"
    >
      <div className="absolute inset-0 honeycomb-divider opacity-30 pointer-events-none" />
      <div className="absolute top-0 right-0 h-72 w-72 rounded-full bg-bee-honey/20 blur-3xl" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-10 items-center">
          <div className="lg:col-span-7">
            <div className="text-xs uppercase tracking-[0.2em] text-bee-honey font-semibold mb-3">Bulk Hiring</div>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight leading-[1.05]">
              Bulk hiring,{" "}
              <span className="text-bee-honey">built for scale.</span>
            </h2>
            <p className="mt-5 text-base lg:text-lg text-white/75 max-w-2xl">
              Whether you need to hire 10 candidates or 1,000, WorkingBees has the infrastructure, network,
              and process to deliver. We run structured drives tailored to your industry, timeline, and workforce.
            </p>

            <div className="mt-10 grid sm:grid-cols-3 gap-4">
              {features.map((f) => (
                <div
                  key={f.title}
                  data-testid={`bulk-feature-${f.title.toLowerCase()}`}
                  className="rounded-2xl bg-white/5 backdrop-blur border border-white/10 p-5"
                >
                  <span className="h-10 w-10 rounded-lg bg-bee-honey text-bee-teal-dark inline-flex items-center justify-center">
                    <f.icon className="h-5 w-5" />
                  </span>
                  <div className="mt-3 font-display text-xl font-bold">{f.title}</div>
                  <div className="text-sm text-white/70 mt-1">{f.desc}</div>
                </div>
              ))}
            </div>

            <div className="mt-10">
              <Button
                size="lg"
                onClick={scrollToContact}
                data-testid="bulk-cta-request"
                className="bg-bee-honey text-bee-teal-dark hover:bg-white rounded-full px-7 h-12 font-semibold"
              >
                Request a Bulk Hiring Drive
                <ArrowRight className="ml-2 h-4 w-4" />
              </Button>
            </div>
          </div>

          <div className="lg:col-span-5">
            <div className="relative rounded-3xl overflow-hidden aspect-[4/5] border border-white/10">
              <img
                src="https://images.unsplash.com/photo-1573164713988-8665fc963095?w=900&auto=format&fit=crop&q=80"
                alt="Bulk recruitment drive"
                className="absolute inset-0 w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-bee-teal-dark via-bee-teal-dark/40 to-transparent" />
              <div className="absolute bottom-6 left-6 right-6">
                <div className="text-xs uppercase tracking-[0.2em] text-bee-honey">Industry tracks</div>
                <div className="mt-2 flex flex-wrap gap-2">
                  {["BFSI", "IT", "Manufacturing", "Retail", "Healthcare"].map((t) => (
                    <span key={t} className="px-2.5 py-1 rounded-full bg-white/15 text-xs font-medium">{t}</span>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
